import i from "./ghl-ui.es391.js";
function u(e, n) {
  return n = typeof n == "function" ? n : void 0, e && e.length ? i(e, void 0, n) : [];
}
export {
  u as default
};
